import BrowserDetection from '@/services/BrowserDetection';
import ThemeMixin from '@/mixins/ThemeMixin';

export default {
  mixins: [ThemeMixin],

  methods: {
    getEmail() {
      // When compiled, all if-statements are removed by webpack
      return 'support@boldsolution.com';
    },

    getCustomLogoUrl() {
      if (APP_TARGET === "bmw")
        return window.location.hostname.includes("bmwmotorrad") 
          ? '/static/img/bmw_motorrad_logo_2021.svg' 
          : '/static/img/BMW2021_logo_400_80.png';
      else if (APP_TARGET === "lambo") return '/static/img/logo.lamborghini.415x70px.png';
      else if (APP_TARGET === "aldisued") return '/static/img/logo.aldisued.83x100px.svg';
      else if (APP_TARGET === "ford") return '/static/img/logo-ford.png';
      else if (APP_TARGET === "jaguar") return '/static/img/logo-jaguar.png';
      else if (APP_TARGET === "obi") return '/static/img/Obi_366px.png';
      else if (APP_TARGET === "obinext") return '/static/img/obi-next-logo.png';
      else if (APP_TARGET === "porsche") return '/static/img/logo.porsche.415x70px.png';
      else if (APP_TARGET === "porschesar") return '/static/img/logo.porsche.415x70px.png';
      //else if (APP_TARGET === "renault") return '/static/img/Renault.png';
      else if (APP_TARGET === "vwag") return '/static/img/VWAG_Logo.png';
      else if (APP_TARGET === "audi") return '/static/img/Audi_Logo.png';
      else if (APP_TARGET === "db") return '/static/img/Logo_ServiceStoreDB.png';
      else return null;
    },

    isDemo() {
      if (APP_TARGET === "ford") return true;
      else if (APP_TARGET === "jaguar") return true;
      else if (APP_TARGET === "vwag") return true;
      else if (APP_TARGET === "demo") return true;
      else return false;
    },

    hasMapView() {
      if (APP_TARGET === "bmw") return true;
      else return false;
    },

    getMapsApiKey() {
      if (APP_TARGET === "bmw") return process.env.VUE_APP_BMW_GOOGLEMAPS_API_KEY;
      else return "KEY NOT CONFIGURED!!!";
    },

    hasDashboard() {
      return true;
    },

    hasDashboardCustomerSelection() {
      if (APP_TARGET === "obi") return true;
      else return false;
    },

    isDashboardTotalScoreWidgetEnabled() {
      if (APP_TARGET === "db") return false;
      else return true;
    },

    hiddenResultKpiGroups() {
      if (APP_TARGET === "db") return ['Zielerreichung'];
      else return [];
    },

    hasCheckExplorer() {
      if (APP_TARGET === "renault") return false;
      else return true;
    },

    hasComparision() {
      if (APP_TARGET === "bmw") {
        if (!window.location.hostname.includes("bmwmotorrad")) {
          return true;
        }
      }
      else return false;
    },
    hasStaticDocument(type) {
      if (type === 'kpi-explanation' && window.location.hostname.includes("bmwmotorrad"))
        return true;
      return false;
    },

    hasSurveyImprovement() {
      return APP_TARGET === "bmw";
    },

    isKpiDefaultMode() {
      if (APP_TARGET === "db") return true;
      else return false;
    },

    hasRawDataPointSelection() {
      if (APP_TARGET === "audi") return false;
      else return true;
    },

    limitText(count) {
      return this.$t('Webportal.LimitText', { count });
    },

    initializeTheme() {
      if (APP_TARGET === "jlr") {
        const initUserTheme = this.getTheme() || this.getMediaPreference();
        this.setTheme(initUserTheme);
      } else {
        // do intentionally nothing
      }
    },
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } },
      browserIsIE: BrowserDetection.isIE()
    };
  }
};
